<template>
    <footer class="footer-wrapper">
        <social-follow />

        <div class="footer-copyright-box">
            <p>&copy; All rights reserved by <a href="https://themeforest.net/user/widethemes/portfolio">WideThemes</a></p>
        </div>
    </footer>
</template>

<script>
import SocialFollow from './SocialFollow.vue';

export default {
    name: 'OhiloFooter',
    components: {
        SocialFollow
    }
}
</script>